import React from 'react';
import classnames from 'classnames';

import { useWindowDimensions } from '../../../hooks/useWindowDimensions';
import Map from '../../Map';
import { HeroMapFragment } from '../../../../graphql.schema';

import * as styles from './StrapiHeroMap.module.scss';

export type HeroMapProps = HeroMapFragment & {
  defaultCenter?: { lat: string, lng: string } | null;
  schoolSlugBase?: string;
  selectedTags?: string[];
  shouldOpenLocationCard?: boolean;
  isSideMap?: boolean;
};

export const StrapiHeroMap = ({
  mapTitle = '',
  isSideMap,
  markers,
  defaultCenter,
  mapDefaultZoom,
  ...props
}: HeroMapProps) => {
  defaultCenter = { lat: markers?.[0]?.mapLocation?.latitude ?? markers?.[0]?.lat, lng: markers?.[0]?.mapLocation?.longitude ?? markers?.[0]?.lng };
  const { innerWidth } = useWindowDimensions();

  return (
    <div className={classnames(isSideMap ? styles.heroMapWrapper : '', 'container')}>
      <Map
        {...props}
        height={`${innerWidth < 1500 ? '300px' : '634px'}`}
        defaultZoom={mapDefaultZoom ?? 6}
        markers={markers}
        width="100%"
        defaultCenter={defaultCenter}
        mapOptions={{
          scrollwheel: false,
          streetViewControl: false,
          fullscreenControl: false,
          mapTypeControl: false,
          scaleControl: false,
          panControl: false,
          rotateControl: false,
          clickableIcons: false,
        }}
      />
      {mapTitle && (
        <div className={styles.mainTitleWrapper}>
          <h1 className={classnames(styles.mainTitle, 'title is-1 brand-a')}>{mapTitle}</h1>
        </div>
      )}
    </div>
  );
};
